
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "GoogleMapView",
  props: {
    address: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    // Google mapで表示するために文字の変換を行う
    const formatAddress = () => {
      return props.address.replace(" ", "");
    };
    const srcUrl = computed(() => {
      return `https://maps.google.co.jp/maps?output=embed&q=${formatAddress()}&z=16`;
    });

    return {
      srcUrl
    };
  }
});
